import React, { Component } from 'react';
import Header from '../../layout/header/header'
import Footer from '../../layout/footer/footer'
import pBanner from '../../assets/p-banner.png'
import i1 from '../../assets/i1.png'
import i2 from '../../assets/i2.png'
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import '../register-as-professional/registerAsProfessional.css';

class registerAsProfessional extends Component {

  constructor(props){
    super(props);
    this.state = {
      phone: "",
    }
  }
    render() {
        return (
            <div>
                <Header/>

                  {/* <!-- banner start --> */}
    <section className="prof_banner">
      <div className="container-fluid">
        <div className="row align-items-center">
          <div className="col-md-7">
            <h2>Join our Professional team 
                and earn more</h2>
            <p>Enroll to be a part of best service providers
                across UAE</p>
          </div>
          <div className="col-md-5">
            <img className="img-fluid" src={pBanner} alt="img" />
          </div>
        </div>
      </div>
    </section>
    {/* <!-- banner end --> */}

    <div className="details_our_team">
      <div className="container-fluid">
        <div className="dtl_our_team_inr">
        <h2>Fill out the details and our team will reach out to you</h2>
        <form>
          <div className="form-group">
            <input type="text" className="form-control" id="name" placeholder="Name" />
            {/* <input type="number" className="form-control" id="number" placeholder="Enter Phone Number" /> */}
            <PhoneInput
             country={'us'}
              value={this.state.phone}
             onChange={phone => this.setState({ phone })}
             />
            <input type="email" className="form-control" id="email" placeholder="Email Address" />
          </div>
          <div className="form-group">
            <input type="text" className="form-control" id="name" placeholder="Emirates ID" />
            <span>OR</span>
            <input type="text" className="form-control" id="name" placeholder="Visa/Passport ID" />
          </div>
          <div className="service_provided">
            <h4>Service Provided :- </h4>
            <div className="checkbox_inr">
              <div className="checkbox_section">
                <div className="form-check">
                  <input className="form-check-input" type="checkbox" value="" id="defaultCheck1" />
                  <label className="form-check-label" for="defaultCheck1">
                    AC Repairing
                  </label>
                </div>
              </div>
              <div className="checkbox_section">
                <div className="form-check">
                  <input className="form-check-input" type="checkbox" value="" id="defaultCheck2" />
                  <label className="form-check-label" for="defaultCheck2">
                    AC Repairing
                  </label>
                </div>
              </div>
              <div className="checkbox_section">
                <div className="form-check">
                  <input className="form-check-input" type="checkbox" value="" id="defaultCheck3" />
                  <label className="form-check-label" for="defaultCheck3">
                    AC Repairing
                  </label>
                </div>
              </div>
              <div className="checkbox_section">
                <div className="form-check">
                  <input className="form-check-input" type="checkbox" value="" id="defaultCheck4" />
                  <label className="form-check-label" for="defaultCheck4">
                    AC Repairing
                  </label>
                </div>
              </div>
            </div>
            <div className="checkbox_inr">
              <div className="checkbox_section">
                <div className="form-check">
                  <input className="form-check-input" type="checkbox" value="" id="defaultCheck5" />
                  <label className="form-check-label" for="defaultCheck5">
                    AC Repairing
                  </label>
                </div>
              </div>
              <div className="checkbox_section">
                <div className="form-check">
                  <input className="form-check-input" type="checkbox" value="" id="defaultCheck6" />
                  <label className="form-check-label" for="defaultCheck6">
                    AC Repairing
                  </label>
                </div>
              </div>
              <div className="checkbox_section">
                <div className="form-check">
                  <input className="form-check-input" type="checkbox" value="" id="defaultCheck7" />
                  <label className="form-check-label" for="defaultCheck7">
                    AC Repairing
                  </label>
                </div>
              </div>
              <div className="checkbox_section">
                <div className="form-check">
                  <input className="form-check-input" type="checkbox" value="" id="defaultCheck8"/>
                  <label className="form-check-label" for="defaultCheck8">
                    AC Repairing
                  </label>
                </div>
              </div>
            </div>
            <div className="checkbox_inr">
              <div className="checkbox_section">
                <div className="form-check">
                  <input className="form-check-input" type="checkbox" value="" id="defaultCheck9" />
                  <label className="form-check-label" for="defaultCheck9">
                    AC Repairing
                  </label>
                </div>
              </div>
              <div className="checkbox_section">
                <div className="form-check">
                  <input className="form-check-input" type="checkbox" value="" id="defaultCheck9" />
                  <label className="form-check-label" for="defaultCheck9">
                    AC Repairing
                  </label>
                </div>
              </div>
              <div className="checkbox_section">
                <div className="form-check">
                  <input className="form-check-input" type="checkbox" value="" id="defaultCheck9" />
                  <label className="form-check-label" for="defaultCheck9">
                    AC Repairing
                  </label>
                </div>
              </div>
              <div className="checkbox_section">
                <div className="form-check">
                  <input className="form-check-input" type="checkbox" value="" id="defaultCheck9" />
                  <label className="form-check-label" for="defaultCheck9">
                    AC Repairing
                  </label>
                </div>
              </div>
            </div>
            <div className="checkbox_inr">
              <div className="checkbox_section">
                <div className="form-check">
                  <input className="form-check-input" type="checkbox" value="" id="defaultCheck9" />
                  <label className="form-check-label" for="defaultCheck9">
                    AC Repairing
                  </label>
                </div>
              </div>
              <div className="checkbox_section">
                <div className="form-check">
                  <input className="form-check-input" type="checkbox" value="" id="defaultCheck9" />
                  <label className="form-check-label" for="defaultCheck9">
                    AC Repairing
                  </label>
                </div>
              </div>
              <div className="checkbox_section">
                <div className="form-check">
                  <input className="form-check-input" type="checkbox" value="" id="defaultCheck9" />
                  <label className="form-check-label" for="defaultCheck9">
                    AC Repairing
                  </label>
                </div>
              </div>
              <div className="checkbox_section">
                <div className="form-check">
                  <input className="form-check-input" type="checkbox" value="" id="defaultCheck9" />
                  <label className="form-check-label" for="defaultCheck9">
                    AC Repairing
                  </label>
                </div>
              </div>
            </div>             
          </div>
          <div className="other_details">
            <h4>Other Details</h4>
              <div className="form-group">
                <textarea className="form-control" id="exampleFormControlTextarea1" rows="3"></textarea>
              </div>
          </div>
        </form>
          <div className="submit_btn text-center">
          <button class="btn btn_design" data-toggle="modal" data-target="#exampleModal">Submit</button>
          </div>

        </div>
      </div>
    </div>
    <Footer/>

    <div className="modal fade profess_model" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div className="modal-dialog modal-lg modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-body">
            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
            <h2>Thank You for Registering as a profesional </h2>
            <p>Your application was succesfully submitted Our team will get in touch with you soon</p>
          </div>
          <div className="modal-footer">
            <div className="row ">
              <div className="col-md-6">
                <p>Download Our Service App and 
                  get along With our Professionals</p>
              </div>
              <div className="col-md-6 d-flex align-items-center">
                <div className="row align-items: center;">
                  <div className="col-md-6">
                    <img className="img-fluid" src={i2} alt="img"/>
                  </div>
                  <div className="col-md-6">
                    <img className="img-fluid mb-3" src={i1} alt="img"/>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
            </div>
        );
    }
}

export default registerAsProfessional;
